// extracted by mini-css-extract-plugin
module.exports = {"carCardWrapper":"_3uAUy","selected":"qXdA5","carImage":"_39mAG","carDetail":"_3TVZ1","sectionHeader":"_3m2l3","regNo":"_2dY_f","contentSection":"_11Tkl"};